import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/Tabs/SelfContainedTabs';
import { AppState } from '../../../../../../types/store';
import { getTimePeriod } from '../../../../../selectors/statsSection';
import { setTimePeriod } from '../../../../../actions/statsSection';
import { timePeriods } from '../../consts';

export type StaticProps = Pick<Props, 'items'>;
export type StateProps = Pick<Props, 'activeIndex'>;
export type DispatchProps = Pick<Props, 'onChange'>;
export type OwnProps = Without<
  Props,
  keyof (StaticProps & StateProps & DispatchProps)
>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const activeTimePeriod = getTimePeriod(state);
  const timePeriodsWithBi = timePeriods.map(item => {
    return {
      ...item,
      biData: {
        ...item.biData,
        is_viewing_same_option: item.index === activeTimePeriod ? 1 : 0,
      },
    };
  });
  return {
    items: timePeriodsWithBi,
    activeIndex: activeTimePeriod,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onChange: setTimePeriod,
};

export default connect(mapStateToProps, mapDispatchToProps);
